import StatisticsTable from './StatisticsTable';

export default StatisticsTable;
